import { QueryObject } from 'bernie-core';
import { KeyedObject } from 'bernie-core/dist/source';
import { ActivitySearchStore } from '../stores';
import { ActivitySelectedValueInput, Url } from '../common/__generated__/api';
export type TargetElements = string | number | object | boolean;

export function equals(obj1: TargetElements, obj2: TargetElements): boolean {
  if (obj1 && obj2) {
    return obj1 === obj2;
  }

  return !obj1 && !obj2;
}

export const addIfNotPresent = (
  array: Array<ActivitySelectedValueInput>,
  element: ActivitySelectedValueInput
): void => {
  if (array && element) {
    const present = array.some(el => el.id === element.id && el.value === element.value);

    if (!present) {
      array.push(element);
    }
  }
};

export function getSeeAllURL(url: Url, params: QueryObject): Url {
  let stringToAppend = '';
  for (const key in params) {
    if (url.indexOf(key) === -1) {
      stringToAppend += `&${key}=${params[key]}`;
    }
  }

  return url + stringToAppend;
}

export function getPageId(activitySearchStore: ActivitySearchStore | undefined): string {
  if (activitySearchStore === undefined) {
    activitySearchStore = {} as ActivitySearchStore;
  }

  return activitySearchStore.pageInfo ? activitySearchStore.pageInfo.pageId : 'SR';
}

export function getPageSize(activitySearchStore: ActivitySearchStore | undefined): number {
  if (activitySearchStore === undefined) {
    activitySearchStore = {} as ActivitySearchStore;
  }

  return activitySearchStore?.paginationInfo ? activitySearchStore.paginationInfo.pageSize : 0;
}

export function getFilteredObjectKeys(object: KeyedObject, filterKey?: string | null): string[] {
  const keys = Object.keys(object);
  if (filterKey) {
    return keys.filter(key => key.includes(filterKey));
  }

  return keys;
}

export const getGraphqlURL = (headers: any, config: KeyedObject): string => {
  let url: string;

  if (config.environment.name !== 'production' && headers?.cookie?.includes('lxpwastubmode=true')) {
    const protocol = headers.host.includes('localhost') || headers.host.includes('sandbox') ? 'http://' : 'https://';
    url = `${protocol}${headers.host}${config.graphqlStubURL}`;
  } else {
    url = config.graphqlURL;
  }

  return url;
};
